window.Extranet ?= {}

Extranet.Constants =
  BLACKOUT_TOGGLE_DURATION: 200
  RESTRICTIONS_TOGGLE_DURATION: 200
